/* The player URL for a tutorial's video link, or null when the link isn't one
   we can play. The desk pastes whatever link they have, so any of these work:

     YouTube  youtube.com/watch?v=ID · youtu.be/ID · /shorts/ID · /live/ID · /embed/ID
     Loom     loom.com/share/ID · loom.com/embed/ID

   The API checks links with the same rules (pow-api utilities/videoLinks.js);
   keep the two in step. */
export function videoEmbedUrl(url) {
  let u;
  try { u = new URL(String(url || '').trim()); } catch { return null; }
  if (u.protocol !== 'https:' && u.protocol !== 'http:') return null;
  const host = u.hostname.toLowerCase().replace(/^(www\.|m\.)/, '');

  if (host === 'youtu.be' || host === 'youtube.com' || host === 'youtube-nocookie.com') {
    const id = host === 'youtu.be'
      ? u.pathname.slice(1).split('/')[0]
      : u.searchParams.get('v') || u.pathname.match(/^\/(?:embed|shorts|live)\/([^/?]+)/)?.[1];
    return id && /^[\w-]{6,}$/.test(id) ? `https://www.youtube.com/embed/${id}` : null;
  }

  if (host === 'loom.com') {
    const id = u.pathname.match(/^\/(?:share|embed)\/([\w-]+)/)?.[1];
    return id ? `https://www.loom.com/embed/${id}` : null;
  }

  return null;
}

export const isVideoUrl = (url) => videoEmbedUrl(url) != null;
